import React, { useState } from "react";
import { Form, Button, Card, Row, Col } from "react-bootstrap";
import axiosClient from "../../../api/axiosClient";

const UserInfoTab = ({ user, refreshUser }) => {
  const [formData, setFormData] = useState({
    username: user.username,
    password: "",
    email: user.email,
    status: !!user.status,
  });

  const [photoFile, setPhotoFile] = useState(null);
  const [preview, setPreview] = useState(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handlePhotoSelect = (e) => {
    const file = e.target.files[0];
    setPhotoFile(file);
    if (file) {
      setPreview(URL.createObjectURL(file));
    }
  };

  const uploadPhoto = async () => {
    if (!photoFile) return alert("Please choose a file");

    const form = new FormData();
    form.append("photo", photoFile);

    try {
      await axiosClient.post(`/users/${user.id}/upload-photo`, form, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      alert("Photo uploaded successfully");
      refreshUser();
      setPreview(null);
      setPhotoFile(null);
    } catch (err) {
      alert("Upload failed");
    }
  };

  const handleUpdate = async () => {
    try {
      await axiosClient.put(`/users/${user.id}`, formData);
      alert("User updated successfully");
      refreshUser();
    } catch (err) {
      alert(err.response?.data?.message || "Update failed");
    }
  };

  const handleDelete = async () => {
    if (!window.confirm("Delete this user?")) return;

    await axiosClient.delete(`/users/${user.id}`);
    alert("User deleted");
    window.location.href = "/admin/users";
  };

  return (
    <div className="p-3">

      {/* SECTION: Profile Card */}
      <Card className="shadow-sm mb-4">
        <Card.Body>
          <h5 className="fw-bold mb-3">User Profile</h5>

          <Row>
            <Col xs={12} md={4} className="text-center mb-3">
              <img
                src={
                  preview
                    ? preview
                    : user.photo
                    ? `http://localhost:5000${user.photo}`
                    : "https://via.placeholder.com/120?text=No+Photo"
                }
                width="120"
                height="120"
                className="rounded-circle border"
                alt="profile"
                style={{ objectFit: "cover" }}
              />

              <div className="mt-3">
                <Form.Control type="file" onChange={handlePhotoSelect} />

                <Button
                  size="sm"
                  className="mt-2"
                  variant="outline-primary"
                  onClick={uploadPhoto}
                >
                  Upload Photo
                </Button>
              </div>
            </Col>

            <Col xs={12} md={8}>
              <p className="mb-1">
                <strong>ID:</strong> {user.id}
              </p>
              <p className="mb-1">
                <strong>Email:</strong> {user.email}
              </p>
              <p className="mb-1">
                <strong>Status:</strong>{" "}
                {user.status ? (
                  <span className="text-success fw-semibold">Active</span>
                ) : (
                  <span className="text-danger fw-semibold">Inactive</span>
                )}
              </p>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* SECTION: Update Form */}
      <Card className="shadow-sm">
        <Card.Body>
          <h5 className="fw-bold mb-3">Edit User Information</h5>

          <Form>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Username</Form.Label>
                  <Form.Control
                    name="username"
                    value={formData.username}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Password (leave blank to keep current)</Form.Label>
                  <Form.Control
                    type="password"
                    name="password"
                    value={formData.password}
                    placeholder="••••••••"
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>

              <Col md={6} className="d-flex align-items-center">
                <Form.Check
                  type="checkbox"
                  label="Active User"
                  name="status"
                  checked={formData.status}
                  onChange={handleChange}
                />
              </Col>
            </Row>

            {/* ACTION BUTTONS */}
            <div className="mt-3 d-flex flex-wrap gap-2">
              <Button variant="primary" onClick={handleUpdate}>
                Save Changes
              </Button>

              <Button variant="outline-danger" onClick={handleDelete}>
                Delete User
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default UserInfoTab;
